/* global PubSub */
window._define('common/pubsub', ['constants'], function (constants) { 'use strict';

    function register(eventName, func) {
        if (!constants.EVENT[eventName]) {
            constants.EVENT[eventName] = eventName;
        }

        PubSub.subscribe(eventName, func);
    }

    return {
        EVENT: constants.EVENT,
        register: register,
        subscribe: PubSub.subscribe,
        publish: PubSub.publish,
    };
});
